// import React, { useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import TextField from "@material-ui/core/TextField";
// import Modal from "react-bootstrap/Modal";
// import { useAppDispatch, useAppSelector } from "../../useStore";
// import { Spinners } from "../TableOptions";
// import {
//   reset,
//   updateInterviewStatus,
// } from "../../features/Applicant/applicantSlice";
// import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import ModalHeader from "../ModalHeader";

// const InterviewUpdateModal = ({ nametitle, name, id, disabled }: any) => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const {
//     updateInterviewStatusisError,
//     updateInterviewStatusmessage,
//     updateInterviewStatusisLoading,
//     updateInterviewStatusisSuccess,
//   } = useAppSelector((state: { applicant: any }) => state.applicant);

//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);


//   const [inputs, setInputs] = useState({
//     status: "COMPLETED",
//     comment: "",
//     interviewScore: "",
//     id: "",
//   });


//   useEffect(() => {
//     if (updateInterviewStatusisError) {
//       swal({
//         title: "error",
//         text: updateInterviewStatusmessage,
//         icon: "error",
//       });
//     } else if (updateInterviewStatusisSuccess) {
//       swal({
//         title: "success",
//         text: "Applicant Interview is now Completed!",
//         icon: "success",
//       });
//       setShow(false);
//       setInputs({
//         status: "",
//         comment: "",
//         interviewScore: "",
//         id: "",
//       });
//     }
//     dispatch(reset());
//   }, [
//     updateInterviewStatusisError,
//     updateInterviewStatusisSuccess,
//     updateInterviewStatusmessage,
//     dispatch,
//     navigate,
//   ]);

//   // const handleOnChange = (input: any, value: any) => {
//   //   setInputs((prevState: any) => ({
//   //     ...prevState,
//   //     [input]: value,
//   //   }));
//   // };
//   // const handleOnChange = (field, value) => {
//   //   // Check if field is 'interviewScore' and validate range
//   //   if (field === "interviewScore") {
//   //     const score = Math.max(0, Math.min(100, parseInt(value) || 0));
//   //     setInputs((prev) => ({
//   //       ...prev,
//   //       [field]: score,
//   //     }));
//   //   } else {
//   //     setInputs((prev) => ({
//   //       ...prev,
//   //       [field]: value,
//   //     }));
//   //   }
//   // };
  
//   const handleOnChange = (input: any, value: any) => {
//     // Initialize the score variable
//     let score = value;
  
//     // Only process the interview score if the input is 'interviewScore'
//     if (input === "interviewScore") {
//       // Convert the value to a number and enforce the range
//       score = Math.max(0, Math.min(100, Number(value)));
  
//       // Ensure score is an integer for the TextField
//       score = Math.round(score);
//     }
  
//     // Update the state with the processed value
//     setInputs((prevState: any) => ({
//       ...prevState,
//       [input]: score,
//     }));
//   };
  
//   useEffect(() => {
//     setInputs((prevState: any) => {
//       return {
//         ...prevState,
//         id: id,
//       };
//     });
//   }, [inputs.id, setInputs, id]);

//   const handleScreening = () => {

//     // @ts-ignore
//     dispatch(updateInterviewStatus(inputs));
//   };
//   return (
//     <a>
//       <div
//         onClick={() => {
//           if (disabled) {
//             toast.success("Interview Completed!");
//           } else {
//             handleShow();
//           }
//         }}
//         className="more-button"
//       >
//         <Button className={disabled ? "view-job-profile more-button-disabled" : "view-job-profile update"}>
//           {disabled ? "No Schedule Yet" : "Update Interview Status"}
//         </Button>
//       </div>


//       <Modal show={show} onHide={handleClose}>
//         <ModalHeader setShow={setShow} headerTitle={"Update Interview Status"} />
//         <Modal.Body>
//           <form>
//             <div className="applicant-name">
//               <h5>Applicant Name</h5>
//               <p>{nametitle + " " + name} </p>
//             </div>
//             <br />
//             <div className="reviewer-name">
//               <h6 className="mt-4">Update Interview Status</h6>
//               <TextField
//                 id="outlined-basic"
//                 variant="outlined"
//                 className="round"
//                 style={{ margin: "10px 0" }}
//                 fullWidth
//                 disabled
//                 value={inputs.status}
//                 onChange={(e) => handleOnChange("status", e.target.value)}
//                 inputProps={{ min: 0, max: 100 }}
//               />
//               <h6 className="mt-4">Interview Score</h6>
//               <TextField
//                 id="outlined-basic"
//                 type="number"
//                 variant="outlined"
//                 className="round"
//                 style={{ margin: "10px 0" }}
//                 fullWidth
//                 value={inputs.interviewScore}
//                 onChange={(e) => handleOnChange("interviewScore", e.target.value)}
//               />

//               <div className="comment mt-4">
//                 <h6>Comment</h6>
//                 <TextField
//                   id="outlined-multiline-static"
//                   multiline
//                   fullWidth
//                   type="text"
//                   minRows={4}
//                   variant="outlined"
//                   style={{ margin: "10px 0" }}
//                   value={inputs.comment}
//                   onChange={(e) => handleOnChange("comment", e.target.value)}

//                 />
//               </div>
//             </div>
//           </form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>
//             Cancel
//           </Button>
//           <Button id="primary" onClick={handleScreening}>
//             {updateInterviewStatusisLoading ? <Spinners size={"sm"} /> : "Send"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </a>
//   );
// };
// export default InterviewUpdateModal;

import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { Spinners } from "../TableOptions";
import {
  reset,
  updateInterviewStatus,
} from "../../features/Applicant/applicantSlice";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ModalHeader from "../ModalHeader";

const InterviewUpdateModal = ({ nametitle, name, id, disabled }: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    updateInterviewStatusisError,
    updateInterviewStatusmessage,
    updateInterviewStatusisLoading,
    updateInterviewStatusisSuccess,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [inputs, setInputs] = useState({
    status: "COMPLETED",
    comment: "",
    interviewScore: "",
    id: "",
  });

  useEffect(() => {
    if (updateInterviewStatusisError) {
      swal({
        title: "Error",
        text: updateInterviewStatusmessage,
        icon: "error",
      });
    } else if (updateInterviewStatusisSuccess) {
      swal({
        title: "Success",
        text: "Applicant Interview is now Completed!",
        icon: "success",
      });
      setShow(false);
      setInputs({
        status: "COMPLETED",  // Resetting to default status
        comment: "",
        interviewScore: "",
        id: "",
      });
    }
    dispatch(reset());
  }, [
    updateInterviewStatusisError,
    updateInterviewStatusisSuccess,
    updateInterviewStatusmessage,
    dispatch,
    navigate,
  ]);

  const handleOnChange = (input: string, value: string) => {
    let processedValue = value;

    // Only process the interviewScore if the input is 'interviewScore'
    if (input === "interviewScore") {
      // Convert the value to a number and enforce the range
      processedValue = Math.max(0, Math.min(100, Number(value))).toString();
    }

    setInputs((prevState) => ({
      ...prevState,
      [input]: processedValue,
    }));
  };

  useEffect(() => {
    setInputs((prevState) => ({
      ...prevState,
      id: id,
    }));
  }, [id]);

  const handleScreening = () => {
    // @ts-ignore
    dispatch(updateInterviewStatus(inputs));
  };

  return (
    <a>
      <div
        onClick={() => {
          if (disabled) {
            toast.success("Interview Completed!");
          } else {
            handleShow();
          }
        }}
        className="more-button"
      >
        <Button className={disabled ? "view-job-profile more-button-disabled" : "view-job-profile update"}>
          {disabled ? "No Schedule Yet" : "Update Interview Status"}
        </Button>
      </div>

      <Modal show={show} onHide={handleClose}>
        <ModalHeader setShow={setShow} headerTitle={"Update Interview Status"} />
        <Modal.Body>
          <form>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              <p>{nametitle + " " + name} </p>
            </div>
            <br />
            <div className="reviewer-name">
              <h6 className="mt-4">Update Interview Status</h6>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className="round"
                style={{ margin: "10px 0" }}
                fullWidth
                disabled
                value={inputs.status}
                onChange={(e) => handleOnChange("status", e.target.value)}
              />
              <h6 className="mt-4">Interview Score</h6>
              <TextField
                id="outlined-basic"
                type="number"
                variant="outlined"
                className="round"
                style={{ margin: "10px 0" }}
                fullWidth
                value={inputs.interviewScore}
                onChange={(e) => handleOnChange("interviewScore", e.target.value)}
                inputProps={{ min: 0, max: 100 }}
              />

              <div className="comment mt-4">
                <h6>Comment</h6>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  fullWidth
                  type="text"
                  minRows={4}
                  variant="outlined"
                  style={{ margin: "10px 0" }}
                  value={inputs.comment}
                  onChange={(e) => handleOnChange("comment", e.target.value)}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleScreening}>
            {updateInterviewStatusisLoading ? <Spinners size={"sm"} /> : "Send"}
          </Button>
        </Modal.Footer>
      </Modal>
    </a>
  );
};

export default InterviewUpdateModal;